import { Component, OnInit, OnDestroy } from '@angular/core';
import { Module } from '@bciti/types';
import { State } from 'src/app/store';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import { organisationModulesSelector } from 'src/app/global/store/global.selectors';

@Component({
    selector: 'app-user-config',
    templateUrl: './user-config.component.html',
})
export class UserConfigComponent implements OnInit, OnDestroy {
    public plugins = {
        [Module.CARD]: 'admin-config-cards',
        [Module.FAMILY]: 'admin-config-family',
    };

    componentsListToShow: string[] = [];

    private destroy$ = new Subject<void>();

    constructor(private store: Store<State>) {}

    ngOnInit(): void {
        this.store
            .select(organisationModulesSelector)
            .pipe(
                takeUntil(this.destroy$),
                tap((modules) => {
                    const pluginsCopy = { ...this.plugins };
                    Object.entries(pluginsCopy).forEach(([key]) => {
                        if (!modules.includes(Module[key])) {
                            delete pluginsCopy[key];
                        }
                    });
                    this.componentsListToShow = Object.values(pluginsCopy);
                }),
            )
            .subscribe();
    }

    isComponentDisplayed(componentName: string): boolean {
        return this.componentsListToShow.indexOf(componentName) !== -1;
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
